// Auto-generated index file for locale exports
import en from './en'
import fr from './fr'
import nl from './nl'
import de from './de'
import bg from './bg'
import hr from './hr'
import cs from './cs'
import el from './el'
import hu from './hu'
import it from './it'
import pl from './pl'
import pt from './pt'
import ro from './ro'
import sl from './sl'
import es from './es'
import sk from './sk'

const locales = {
  en: en,
  fr: fr,
  nl: nl,
  de: de,
  bg: bg,
  hr: hr,
  cs: cs,
  el: el,
  hu: hu,
  it: it,
  pl: pl,
  pt: pt,
  ro: ro,
  sl: sl,
  es: es,
  sk: sk
}

export default locales
